import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

const LABEL_REST_URL: string = '/rest/label';

@Injectable({
    providedIn: 'root'
})
export class PrlLabelService {

    constructor(
        private httpClient: HttpClient
    ) {}

    public getLabelContent(labelName: string, currentLanguage: string): Observable<string> {
        return this.httpClient.get(`${LABEL_REST_URL}/${currentLanguage}/${labelName}`, {responseType: 'text'});
    }
}
